<template>
  <div
      class="webinars_list d-flex align-items-center">
    <div class="webinars-list-image-wrap not-uploaded">
      <img class="webinars-list-image" src="../../assets/images/common/landscape.svg">
    </div>
    <div class="webinar-information-block">
      <h3 class="webinar-name">{{ webinar.lesson ? webinar.lesson.name : 'Урок удален, но вебинар провести нужно' }}</h3>
      <time class="webinar-time">
        {{ formatDate(webinar.scheduled_date) }}
        <span>|</span> {{ webinar.scheduled_time }}
      </time>
      <div class="webinar-type">{{ webinar.is_past ? '' : 'Активный' }}</div>
    </div>
    <a
        class="exit-header-button btn btn-danger"
        v-if="role === 'teacher' || role === 'admin'"
        @click="$emit('cancelWebinar', webinar.id)"
    >
      Отменить вебинар
    </a>
    <a
        class="exit-header-button btn btn-warning"
        v-if="role === 'teacher' || role === 'admin'"
        @click="openEditModal(webinar.id)"
    >
      Перенести вебинар
    </a>
    <a v-if="role === 'student'"
       class="exit-header-button btn btn-primary"
       @click="enterLessonRoom"
       :class="{ 'btn-secondary': !canJoinLesson }"
       :disabled="!canJoinLesson">
      <div class="img-wrap">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
                d="M14.1406 15.3125V16.875C14.1406 18.5982 12.7388 20 11.0156 20H3.16406C1.44089 20 0.0390625 18.5982 0.0390625 16.875V3.125C0.0390625 1.40182 1.44089 0 3.16406 0H11.0156C12.7388 0 14.1406 1.40182 14.1406 3.125V4.6875C14.1406 5.11902 13.7909 5.46875 13.3594 5.46875C12.9279 5.46875 12.5781 5.11902 12.5781 4.6875V3.125C12.5781 2.26349 11.8771 1.5625 11.0156 1.5625H3.16406C2.30255 1.5625 1.60156 2.26349 1.60156 3.125V16.875C1.60156 17.7365 2.30255 18.4375 3.16406 18.4375H11.0156C11.8771 18.4375 12.5781 17.7365 12.5781 16.875V15.3125C12.5781 14.881 12.9279 14.5312 13.3594 14.5312C13.7909 14.5312 14.1406 14.881 14.1406 15.3125ZM19.467 8.65799L17.7176 6.90857C17.4124 6.60339 16.9177 6.60339 16.6127 6.90857C16.3075 7.21359 16.3075 7.70828 16.6127 8.01331L17.8571 9.25781H8.47656C8.04504 9.25781 7.69531 9.60754 7.69531 10.0391C7.69531 10.4706 8.04504 10.8203 8.47656 10.8203H17.8571L16.6127 12.0648C16.3075 12.3698 16.3075 12.8645 16.6127 13.1696C16.7653 13.3221 16.9652 13.3984 17.1651 13.3984C17.3651 13.3984 17.565 13.3221 17.7176 13.1696L19.467 11.4201C20.2286 10.6586 20.2286 9.41956 19.467 8.65799Z"
                fill="#fff"></path>
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="20" height="20" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      </div>
      <span class="exit-header-text">
        {{ canJoinLesson ? $t('Войти в урок') : (webinar.is_past === 2 ? $t('Урок завершен') : $t('Урок недоступен')) }}
      </span>
    </a>
    <a v-if="role === 'teacher' && webinar.is_past === 1 && webinar.lesson_room_enabled"
       class="exit-header-button btn btn-primary"
       @click="endLessonRoom">
      <div class="img-wrap">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
                d="M14.1406 15.3125V16.875C14.1406 18.5982 12.7388 20 11.0156 20H3.16406C1.44089 20 0.0390625 18.5982 0.0390625 16.875V3.125C0.0390625 1.40182 1.44089 0 3.16406 0H11.0156C12.7388 0 14.1406 1.40182 14.1406 3.125V4.6875C14.1406 5.11902 13.7909 5.46875 13.3594 5.46875C12.9279 5.46875 12.5781 5.11902 12.5781 4.6875V3.125C12.5781 2.26349 11.8771 1.5625 11.0156 1.5625H3.16406C2.30255 1.5625 1.60156 2.26349 1.60156 3.125V16.875C1.60156 17.7365 2.30255 18.4375 3.16406 18.4375H11.0156C11.8771 18.4375 12.5781 17.7365 12.5781 16.875V15.3125C12.5781 14.881 12.9279 14.5312 13.3594 14.5312C13.7909 14.5312 14.1406 14.881 14.1406 15.3125ZM19.467 8.65799L17.7176 6.90857C17.4124 6.60339 16.9177 6.60339 16.6127 6.90857C16.3075 7.21359 16.3075 7.70828 16.6127 8.01331L17.8571 9.25781H8.47656C8.04504 9.25781 7.69531 9.60754 7.69531 10.0391C7.69531 10.4706 8.04504 10.8203 8.47656 10.8203H17.8571L16.6127 12.0648C16.3075 12.3698 16.3075 12.8645 16.6127 13.1696C16.7653 13.3221 16.9652 13.3984 17.1651 13.3984C17.3651 13.3984 17.565 13.3221 17.7176 13.1696L19.467 11.4201C20.2286 10.6586 20.2286 9.41956 19.467 8.65799Z"
                fill="#fff"></path>
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="20" height="20" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      </div>
      <span class="exit-header-text">{{ $t('Закончить урок') }}</span>
    </a>
    <!-- Fallback to old webinar functionality for non-lesson-room webinars -->
    <a v-if="role === 'teacher' && webinar.is_past === 1 && !webinar.lesson_room_enabled"
       class="exit-header-button btn btn-primary"
       @click="endWebinar(id)">
      <div class="img-wrap">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
                d="M14.1406 15.3125V16.875C14.1406 18.5982 12.7388 20 11.0156 20H3.16406C1.44089 20 0.0390625 18.5982 0.0390625 16.875V3.125C0.0390625 1.40182 1.44089 0 3.16406 0H11.0156C12.7388 0 14.1406 1.40182 14.1406 3.125V4.6875C14.1406 5.11902 13.7909 5.46875 13.3594 5.46875C12.9279 5.46875 12.5781 5.11902 12.5781 4.6875V3.125C12.5781 2.26349 11.8771 1.5625 11.0156 1.5625H3.16406C2.30255 1.5625 1.60156 2.26349 1.60156 3.125V16.875C1.60156 17.7365 2.30255 18.4375 3.16406 18.4375H11.0156C11.8771 18.4375 12.5781 17.7365 12.5781 16.875V15.3125C12.5781 14.881 12.9279 14.5312 13.3594 14.5312C13.7909 14.5312 14.1406 14.881 14.1406 15.3125ZM19.467 8.65799L17.7176 6.90857C17.4124 6.60339 16.9177 6.60339 16.6127 6.90857C16.3075 7.21359 16.3075 7.70828 16.6127 8.01331L17.8571 9.25781H8.47656C8.04504 9.25781 7.69531 9.60754 7.69531 10.0391C7.69531 10.4706 8.04504 10.8203 8.47656 10.8203H17.8571L16.6127 12.0648C16.3075 12.3698 16.3075 12.8645 16.6127 13.1696C16.7653 13.3221 16.9652 13.3984 17.1651 13.3984C17.3651 13.3984 17.565 13.3221 17.7176 13.1696L19.467 11.4201C20.2286 10.6586 20.2286 9.41956 19.467 8.65799Z"
                fill="#fff"></path>
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="20" height="20" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      </div>
      <span class="exit-header-text">{{ $t('Закончить вебинар') }}</span>
    </a>
    <a v-if="role === 'teacher' && webinar.is_past !== 1 && webinar.lesson_room_enabled"
       class="exit-header-button btn btn-primary"
       @click="startLessonRoom">
      <div class="img-wrap">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
                d="M14.1406 15.3125V16.875C14.1406 18.5982 12.7388 20 11.0156 20H3.16406C1.44089 20 0.0390625 18.5982 0.0390625 16.875V3.125C0.0390625 1.40182 1.44089 0 3.16406 0H11.0156C12.7388 0 14.1406 1.40182 14.1406 3.125V4.6875C14.1406 5.11902 13.7909 5.46875 13.3594 5.46875C12.9279 5.46875 12.5781 5.11902 12.5781 4.6875V3.125C12.5781 2.26349 11.8771 1.5625 11.0156 1.5625H3.16406C2.30255 1.5625 1.60156 2.26349 1.60156 3.125V16.875C1.60156 17.7365 2.30255 18.4375 3.16406 18.4375H11.0156C11.8771 18.4375 12.5781 17.7365 12.5781 16.875V15.3125C12.5781 14.881 12.9279 14.5312 13.3594 14.5312C13.7909 14.5312 14.1406 14.881 14.1406 15.3125ZM19.467 8.65799L17.7176 6.90857C17.4124 6.60339 16.9177 6.60339 16.6127 6.90857C16.3075 7.21359 16.3075 7.70828 16.6127 8.01331L17.8571 9.25781H8.47656C8.04504 9.25781 7.69531 9.60754 7.69531 10.0391C7.69531 10.4706 8.04504 10.8203 8.47656 10.8203H17.8571L16.6127 12.0648C16.3075 12.3698 16.3075 12.8645 16.6127 13.1696C16.7653 13.3221 16.9652 13.3984 17.1651 13.3984C17.3651 13.3984 17.565 13.3221 17.7176 13.1696L19.467 11.4201C20.2286 10.6586 20.2286 9.41956 19.467 8.65799Z"
                fill="#fff"></path>
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="20" height="20" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      </div>
      <span class="exit-header-text">{{ $t('Начать урок') }}</span>
    </a>
    <!-- Fallback to old webinar functionality for non-lesson-room webinars -->
    <a v-if="role === 'teacher' && webinar.is_past !== 1 && !webinar.lesson_room_enabled" target="_blank"
       class="exit-header-button btn btn-primary"
       @click="startWebinar(id)">
      <div class="img-wrap">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
                d="M14.1406 15.3125V16.875C14.1406 18.5982 12.7388 20 11.0156 20H3.16406C1.44089 20 0.0390625 18.5982 0.0390625 16.875V3.125C0.0390625 1.40182 1.44089 0 3.16406 0H11.0156C12.7388 0 14.1406 1.40182 14.1406 3.125V4.6875C14.1406 5.11902 13.7909 5.46875 13.3594 5.46875C12.9279 5.46875 12.5781 5.11902 12.5781 4.6875V3.125C12.5781 2.26349 11.8771 1.5625 11.0156 1.5625H3.16406C2.30255 1.5625 1.60156 2.26349 1.60156 3.125V16.875C1.60156 17.7365 2.30255 18.4375 3.16406 18.4375H11.0156C11.8771 18.4375 12.5781 17.7365 12.5781 16.875V15.3125C12.5781 14.881 12.9279 14.5312 13.3594 14.5312C13.7909 14.5312 14.1406 14.881 14.1406 15.3125ZM19.467 8.65799L17.7176 6.90857C17.4124 6.60339 16.9177 6.60339 16.6127 6.90857C16.3075 7.21359 16.3075 7.70828 16.6127 8.01331L17.8571 9.25781H8.47656C8.04504 9.25781 7.69531 9.60754 7.69531 10.0391C7.69531 10.4706 8.04504 10.8203 8.47656 10.8203H17.8571L16.6127 12.0648C16.3075 12.3698 16.3075 12.8645 16.6127 13.1696C16.7653 13.3221 16.9652 13.3984 17.1651 13.3984C17.3651 13.3984 17.565 13.3221 17.7176 13.1696L19.467 11.4201C20.2286 10.6586 20.2286 9.41956 19.467 8.65799Z"
                fill="#fff"></path>
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="20" height="20" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      </div>
      <span class="exit-header-text">{{ $t('Начать вебинар') }}</span>
    </a>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import moment from 'moment';
const {mapGetters} = createNamespacedHelpers('user');


export default {

  name: 'index',
  props: {
    webinar: Object,
    startWebinar: {
      required: false,
    },
    endWebinar: {
      required: false,
    },
    id: Number,
  },
  computed: {
    ...mapGetters(['role']),
    canJoinLesson() {
      // Student can join if:
      // 1. Webinar has lesson room enabled
      // 2. Webinar is scheduled (is_past === 0) and it's within 30 minutes of start time
      // 3. Webinar is active (is_past === 1)

      if (!this.webinar.lesson_room_enabled) {
        return false;
      }

      if (this.webinar.is_past === 1) {
        // Webinar is currently active
        return true;
      }

      if (this.webinar.is_past === 0) {
        // Webinar is scheduled, check if it's within join window
        const now = moment();
        const webinarTime = moment(`${this.webinar.scheduled_date} ${this.webinar.scheduled_time}`);
        const minutesUntilStart = webinarTime.diff(now, 'minutes');

        // Allow joining 30 minutes before and 60 minutes after scheduled time
        return minutesUntilStart <= 30 && minutesUntilStart >= -60;
      }

      // Webinar is completed or cancelled
      return false;
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY');
    },
    openEditModal(webinarId) {
      this.$emit('openWebinarChangeModal', webinarId);
    },
    enterLessonRoom() {
      if (this.canJoinLesson) {
        this.$router.push({
          name: 'lessonRoom',
          params: { webinarId: this.webinar.id }
        });
      } else if (this.webinar.is_past === 2) {
        this.$toast({
          component: 'ToastificationContent',
          props: {
            title: 'Lesson Completed',
            text: 'This lesson has already been completed.',
            variant: 'info'
          }
        });
      } else {
        this.$toast({
          component: 'ToastificationContent',
          props: {
            title: 'Lesson Not Available',
            text: 'This lesson is not available yet. Please wait for the scheduled time.',
            variant: 'warning'
          }
        });
      }
    },
    async startLessonRoom() {
      try {
        // Import the lessonRoom API
        const lessonRoomApi = (await import('@/api/lessonRoom')).default;

        // Call the API to mark the lesson as started in the database
        console.log('Starting lesson conference for webinar:', this.webinar.id);
        await lessonRoomApi.startConference(this.webinar.id);
        console.log('Lesson conference started successfully');

        // Navigate to the lesson room
        this.$router.push({
          name: 'lessonRoom',
          params: { webinarId: this.webinar.id }
        });
      } catch (error) {
        console.error('Failed to start lesson:', error);
        this.$toast({
          component: 'ToastificationContent',
          props: {
            title: 'Error',
            text: 'Failed to start the lesson. Please try again.',
            variant: 'danger'
          }
        });
      }
    },
    endLessonRoom() {
      // Teacher method to end the lesson room (same as current endWebinar)
      this.endWebinar(this.id);
    }
  },

};
</script>

<style lang="scss" scoped>
.exit-header-button {
  display: flex;
  margin-left: auto;

  .img-wrap {
    margin-right: 10px;
  }
}

.webinars-list-image-wrap {
  margin-right: 20px;
}

.webinars_list {
  margin-bottom: 30px;
}
</style>
